import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { VisualStyle } from 'types'

export const fetchVisualStyles = async ({ signal }: { signal?: AbortSignal }) => {
  const res = await sendToApi<VisualStyle[]>('/visual_styles', { signal })
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data
}

export const useVisualStyles = (options?: UseQueryOptions<VisualStyle[]>) => {
  return useQuery<VisualStyle[]>(['visualStyles', 'list'], ({ signal }) => fetchVisualStyles({ signal }), {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...options,
  })
}
